module.exports = __webpack_public_path__ + "media/images/gallery/stars/triangulum/alpha_trianguli_vis-3806b790d04aa918d24a2fe027d54a6d.jpg";